import React from "react";
import { BarChart3, Users, Clock, TrendingUp } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import MontagemFilters from "./components/MontagemFilters";
import RankingMontagem from "./components/RankingMontagem";
import StatCard from "../Producao/components/StatCard";
import {
  EstatisticasMontagemProvider,
  useEstatisticasMontagem,
} from "./context/EstatisticasMontagemContext";
import { producaoService } from "../../../services/producaoService";

const EstatisticasMontagemContent: React.FC = () => {
  const {
    startDate,
    endDate,
    selectedLojaId,
    selectedUsuarioId,
    setStartDate,
    setEndDate,
    setSelectedLojaId,
    setSelectedUsuarioId,
    handleApplyFilter,
    lojaOptions,
    usuarioOptions,
    appliedFilters,
    usuariosMontagem,
  } = useEstatisticasMontagem();

  const { data: resumo } = useQuery({
    queryKey: ["montagem-resumo", appliedFilters],
    queryFn: () =>
      producaoService.getResumoMontagem({
        dataInicio: appliedFilters.dataInicio,
        dataFim: appliedFilters.dataFim,
        lojaId: appliedFilters.lojaId,
      }),
    enabled: !!(appliedFilters.dataInicio && appliedFilters.dataFim),
  });

  const totalMontagens = usuariosMontagem.reduce(
    (acc, user) => acc + user.quantidadeProducoes,
    0
  );
  const totalMontadores = usuariosMontagem.length;
  const tempoMedio =
    usuariosMontagem.length > 0 ? usuariosMontagem[0].tempoMedio : "00:00:00";
  const emMontagem = resumo?.totalProducoesEmAndamento || 0;

  return (
    <div className="space-y-6">
      <MontagemFilters
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        lojas={lojaOptions}
        selectedLojaId={selectedLojaId}
        onLojaChange={setSelectedLojaId}
        usuarios={usuarioOptions}
        selectedUsuarioId={selectedUsuarioId}
        onUsuarioChange={setSelectedUsuarioId}
        onApplyFilter={handleApplyFilter}
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatCard
          icon={BarChart3}
          label="Montagens Finalizadas"
          value={totalMontagens}
        />
        <StatCard icon={Users} label="Montadores" value={totalMontadores} />
        <StatCard icon={Clock} label="Tempo Médio" value={tempoMedio} />
        <StatCard icon={TrendingUp} label="Em Montagem" value={emMontagem} />
      </div>

      <RankingMontagem />
    </div>
  );
};

const EstatisticasMontagem: React.FC = () => {
  return (
    <EstatisticasMontagemProvider>
      <EstatisticasMontagemContent />
    </EstatisticasMontagemProvider>
  );
};

export default EstatisticasMontagem;
